// extracted by mini-css-extract-plugin
export default {"edit":"summary-step_edit__OEfYp","long-name-wrapper":"summary-step_long-name-wrapper__gYpsj"};